// Platform metadata for Multichat source channels (Channel::Social,
// Channel::Marketplace) and for conversation source cards.
// Class strings live here (helper/** is scanned by Tailwind) so that
// components can tint badges and icons per platform.

export const SOCIAL_CHANNEL_TYPE = 'Channel::Social';
export const MARKETPLACE_CHANNEL_TYPE = 'Channel::Marketplace';

export const SOCIAL_ENTITY_I18N = {
  comments: 'MULTICHAT.ENTITIES.COMMENTS',
  direct: 'MULTICHAT.ENTITIES.DIRECT',
  mentions: 'MULTICHAT.ENTITIES.MENTIONS',
  messages: 'MULTICHAT.ENTITIES.MESSAGES',
  feedbacks: 'MULTICHAT.ENTITIES.FEEDBACKS',
  questions: 'MULTICHAT.ENTITIES.QUESTIONS',
  returns: 'MULTICHAT.ENTITIES.RETURNS',
  dialogs: 'MULTICHAT.ENTITIES.DIALOGS',
  reviews: 'MULTICHAT.ENTITIES.REVIEWS',
};

export const PLATFORMS = {
  instagram: {
    name: 'MULTICHAT.PLATFORMS.INSTAGRAM',
    icon: 'i-ri-instagram-fill',
    lineIcon: 'i-ri-instagram-line',
    brandIcon: 'i-woot-instagram-color',
    badgeClass:
      'bg-gradient-to-br from-[#F58529] via-[#DD2A7B] to-[#8134AF] text-white',
    textClass: 'text-[#DD2A7B]',
    entities: ['comments', 'direct', 'mentions'],
  },
  youtube: {
    name: 'MULTICHAT.PLATFORMS.YOUTUBE',
    icon: 'i-ri-youtube-fill',
    lineIcon: 'i-ri-youtube-line',
    brandIcon: 'i-logos-youtube-icon',
    badgeClass: 'bg-[#FF0000] text-white',
    textClass: 'text-[#FF0000]',
    entities: ['comments'],
  },
  tiktok: {
    name: 'MULTICHAT.PLATFORMS.TIKTOK',
    icon: 'i-ri-tiktok-fill',
    lineIcon: 'i-ri-tiktok-line',
    brandIcon: 'i-logos-tiktok-icon',
    badgeClass: 'bg-[#111111] text-white',
    textClass: 'text-n-slate-12',
    entities: ['comments', 'direct'],
  },
  ok: {
    name: 'MULTICHAT.PLATFORMS.OK',
    icon: 'i-woot-ok',
    lineIcon: 'i-woot-ok',
    badgeClass: 'bg-[#EE8208] text-white',
    textClass: 'text-[#EE8208]',
    entities: ['comments', 'mentions', 'direct'],
  },
  vk: {
    name: 'MULTICHAT.PLATFORMS.VK',
    icon: 'i-ri-vk-fill',
    lineIcon: 'i-ri-vk-line',
    badgeClass: 'bg-[#0077FF] text-white',
    textClass: 'text-[#0077FF]',
    entities: ['comments', 'mentions', 'direct'],
  },
  x: {
    name: 'MULTICHAT.PLATFORMS.X',
    icon: 'i-ri-twitter-x-fill',
    lineIcon: 'i-ri-twitter-x-line',
    badgeClass: 'bg-[#111111] text-white',
    textClass: 'text-n-slate-12',
    entities: ['comments', 'mentions', 'direct'],
  },
  telegram_bot: {
    name: 'MULTICHAT.PLATFORMS.TELEGRAM_BOT',
    icon: 'i-ri-telegram-fill',
    lineIcon: 'i-ri-telegram-line',
    brandIcon: 'i-logos-telegram',
    badgeClass: 'bg-[#229ED9] text-white',
    textClass: 'text-[#229ED9]',
    entities: ['direct'],
    isBot: true,
  },
  telegram_channel: {
    name: 'MULTICHAT.PLATFORMS.TELEGRAM_CHANNEL',
    icon: 'i-ri-telegram-fill',
    lineIcon: 'i-ri-telegram-line',
    brandIcon: 'i-logos-telegram',
    badgeClass: 'bg-[#229ED9] text-white',
    textClass: 'text-[#229ED9]',
    entities: ['comments'],
  },
  telegram_group: {
    name: 'MULTICHAT.PLATFORMS.TELEGRAM_GROUP',
    icon: 'i-ri-telegram-fill',
    lineIcon: 'i-ri-telegram-line',
    brandIcon: 'i-logos-telegram',
    badgeClass: 'bg-[#229ED9] text-white',
    textClass: 'text-[#229ED9]',
    entities: ['messages'],
  },
  max_bot: {
    name: 'MULTICHAT.PLATFORMS.MAX_BOT',
    icon: 'i-ri-message-3-fill',
    lineIcon: 'i-ri-message-3-line',
    badgeClass: 'bg-gradient-to-br from-[#2A7BFF] to-[#8A3FFC] text-white',
    textClass: 'text-[#6B5BFF]',
    entities: ['direct'],
    isBot: true,
  },
  yandex_market: {
    name: 'MULTICHAT.PLATFORMS.YANDEX_MARKET',
    icon: 'i-ri-store-3-fill',
    lineIcon: 'i-ri-store-3-line',
    badgeClass: 'bg-[#FFCC00] text-[#1A1A1A]',
    textClass: 'text-[#C79A00]',
    entities: ['feedbacks', 'questions', 'returns', 'dialogs'],
  },
  ozon: {
    name: 'MULTICHAT.PLATFORMS.OZON',
    icon: 'i-ri-shopping-bag-4-fill',
    lineIcon: 'i-ri-shopping-bag-4-line',
    badgeClass: 'bg-[#005BFF] text-white',
    textClass: 'text-[#005BFF]',
    entities: ['feedbacks', 'questions', 'returns', 'dialogs'],
  },
  wildberries: {
    name: 'MULTICHAT.PLATFORMS.WILDBERRIES',
    icon: 'i-ri-shopping-cart-2-fill',
    lineIcon: 'i-ri-shopping-cart-2-line',
    badgeClass: 'bg-gradient-to-br from-[#CB11AB] to-[#481173] text-white',
    textClass: 'text-[#CB11AB]',
    entities: ['feedbacks', 'questions', 'returns', 'dialogs'],
  },
  rocketdata: {
    name: 'MULTICHAT.PLATFORMS.ROCKETDATA',
    icon: 'i-ri-map-pin-2-fill',
    lineIcon: 'i-ri-map-pin-2-line',
    badgeClass: 'bg-[#FF5A1F] text-white',
    textClass: 'text-[#FF5A1F]',
    entities: ['reviews'],
  },
  website: {
    name: 'MULTICHAT.PLATFORMS.WEBSITE',
    icon: 'i-ri-global-fill',
    lineIcon: 'i-ri-global-line',
    badgeClass: 'bg-[#E30611] text-white',
    textClass: 'text-[#E30611]',
    entities: [],
  },
  email: {
    name: 'MULTICHAT.PLATFORMS.EMAIL',
    icon: 'i-ri-mail-fill',
    lineIcon: 'i-ri-mail-line',
    badgeClass: 'bg-n-slate-11 text-white',
    textClass: 'text-n-slate-11',
    entities: [],
  },
};

export const MARKETPLACE_PLATFORMS = [
  'yandex_market',
  'ozon',
  'wildberries',
  'rocketdata',
];

export const getPlatform = key => PLATFORMS[key] || null;

export const getInboxPlatform = inbox => {
  if (!inbox) return null;
  const type = inbox.channel_type;
  if (type !== SOCIAL_CHANNEL_TYPE && type !== MARKETPLACE_CHANNEL_TYPE) {
    return null;
  }
  return inbox.platform || inbox.medium || null;
};

export const isSourceChannel = inbox =>
  [SOCIAL_CHANNEL_TYPE, MARKETPLACE_CHANNEL_TYPE].includes(inbox?.channel_type);

export const isBotPlatform = platform => !!PLATFORMS[platform]?.isBot;

export const getPlatformEntities = platform =>
  PLATFORMS[platform]?.entities || [];
